import React from 'react'
import { useTranslation } from 'react-i18next'
import BrushingInstructionsIcon from '../../icons/BrushingInstructionsIcon'
import ChewiesInstructionsIcon from '../../icons/ChewiesInstructionsIcon'
import PatientsWeContactedIcon from '../../icons/PatientsWeContactedIcon'
import BaseWidget from '../../components/common/BaseWidget'
import NumberWidget from '../../components/common/NumberWidget/NumberWidget'

const PatientsWeContacted = ({ total, forBrushing, forChewies, isLoading }) => {
  const { t } = useTranslation()

  return (
    <BaseWidget isLoading={isLoading}>
      <NumberWidget
        isLoading={isLoading}
        key={'patientsContacted'}
        label={t('pages.copilotControl.widgets.patientsWeContacted.title')}
        icon={PatientsWeContactedIcon}
        value={total}
        tooltipText={t('pages.copilotControl.widgets.patientsWeContacted.tooltip')}
      />
      <NumberWidget
        isLoading={isLoading}
        key={'patientsWeSentBrushing'}
        label={t('pages.copilotControl.widgets.patientsWeSentBrushing.title')}
        icon={BrushingInstructionsIcon}
        value={forBrushing}
        tooltipText={t('pages.copilotControl.widgets.patientsWeSentBrushing.tooltip')}
      />
      <NumberWidget
        isLoading={isLoading}
        key={'patientsWeSentChewies'}
        label={t('pages.copilotControl.widgets.patientsWeSentChewies.title')}
        icon={ChewiesInstructionsIcon}
        value={forChewies}
        tooltipText={t('pages.copilotControl.widgets.patientsWeSentChewies.tooltip')}
      />
    </BaseWidget>
  )
}

export default PatientsWeContacted
